
import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import translation_en from './en/translation.json';
import translation_fi from './fi/translation.json';
import LanguageDetector from 'i18next-browser-languagedetector';

i18next.use(LanguageDetector).use(initReactI18next).init({
    supportedLngs: ['en', 'fi'],
    fallbackLng: 'en',
    debug: false,
    resources: {
        en: {
            translation: {...translation_en},
        },
        fi: {
            translation: {...translation_fi},
        }
    },
});